<template>
    <div class="navi-container">
        <div
            class="single-navi"
            index="000"
            @click="toFront"
            :class="{'active': $route.name == 'Welcome'}"
        >首页</div>
        <div
            v-for="(nav,index) in navList"
            :key="nav.id"
            class="single-navi"
            :class="{'active':$route.query.id == nav.id}"
            v-if="index < 7"
            @click="toNav(nav)"
        >{{ nav.label }}</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                navList: [],
                activeIndex: '000'
            };
        },
        created() {
            this.getNavList();
        },
        methods: {
            getNavList() {
                this.httpGet(this.$root.getNavList, {})
                    .then(result => {
                        this.navList.push(...result.list);
                    })
                    .catch(err => {
                        console.error('getNavList-err', err);
                    });
            },
            toNav(item) {
                console.log('iiiiitem', item);
                let breadObj = {
                    name: item.label,
                    path: 'article-list?id=' + item.id
                };
                this.$store.commit('setBreadArr', breadObj);
                this.$router.push({
                    name: 'article-list',
                    query: {
                        id: item.id
                    }
                });
            },
            toFront() {
                this.$router.push({
                    name: 'Welcome'
                });
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .navi-container {
        width: 1180px;
        // width: 78.458%;
        flex-x(center);
    }

    .head-navi {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        max-height: 43.2px;
        overflow-y: hidden;
    }

    .single-navi {
        z-index: 2;
        // width: 150px;
        // width: 14.2857%;
        width: 148px;
        height: 43.2px;
        cursor: pointer;
        font-size: 16px;
        color: white;
        line-height: 22px;
        flex-center();
        background: #005FD9;
    }

    .single-navi:hover {
        background: #272C32;
    }

    .single-navi:last-child {
        width: 144px;
    }

    .active {
        width: 148px;
        background: #272C32;
    }

    .front {
        background: green;
        opacity: 0.9;
    }

    .el-menu {
        padding: 0 !important;
        background: none;
    }

    >>>.el-submenu__title {
        color: white !important;
    }

    >>>.el-submenu__title:hover {
        width: 148px;
        height: 40px;
        background: green;
        opacity: 0.9;
        flex-center();
        border: 0px solid;
        border-bottom: 1px solid #979797;
        color: white;
    }

    .child2sub {
        >>>.el-submenu__title {
            color: #909399 !important;
        }

        >>>.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
            color: #3885D4 !important;
            border-left: #E6A23C 3px solid !important;
            width: 150px;
            background: #fff;
        }

        >>>.el-submenu__title:hover {
            color: #3885D4 !important;
            border-left: #E6A23C 3px solid !important;
            width: 150px;
            background: #fff;
        }

        >>>.el-menu-item .is-active {
            color: #3885D4 !important;
            border-left: #E6A23C 3px solid !important;
            width: 150px;
            background: #fff;
        }
    }
</style>
